import { useTranslation } from 'react-i18next';
import { hasPermission } from '@features/auth/utils/permissionRules';
import { SidebarNavItem } from './SidebarNavItem';

/**
 * Navigation section with a header and list of items
 * @param {Object} props
 * @param {string} props.titleKey - i18n translation key for the section title
 * @param {Array} props.items - Array of navigation items
 * @param {Array} props.userGroups - User's groups for permission filtering
 */
export function SidebarNavSection({ titleKey, items, userGroups }) {
  const { t } = useTranslation();

  const visibleItems = items.filter(item =>
    !item.permission || hasPermission(userGroups, item.permission)
  );

  if (visibleItems.length === 0) return null;

  return (
    <>
      {/* Section Header */}
      <li className="pt-4 hs-overlay-minified:hidden">
        <span className="px-2.5 text-xs font-semibold uppercase text-muted">
          {t(titleKey)}
        </span>
      </li>

      {/* Section Items */}
      {visibleItems.map((item) => (
        <SidebarNavItem
          key={item.path}
          path={item.path}
          labelKey={item.labelKey}
          icon={item.icon}
        />
      ))}
    </>
  );
}
